import React from 'react';
import { HiddenContainer } from './styles';

export interface HiddenProps {
  children?: React.ReactNode | React.ReactNode[];
  lgDown?: boolean;
  lgUp?: boolean;
  mdDown?: boolean;
  mdUp?: boolean;
  smDown?: boolean;
  smUp?: boolean;
  xlDown?: boolean;
  xlUp?: boolean;
  xsDown?: boolean;
  xsUp?: boolean;
}

const Hidden = (props: HiddenProps) => {
  const { children, ...rest } = props;

  return <HiddenContainer {...rest}>{children}</HiddenContainer>;
};

export default Hidden;
